export const brandAggregationFields = /* GraphQL */ `
  fragment brandAggregationFields on BrandAggregation {
    slug
    name
    count
  }
`
